import React, { useState } from "react";
import compoundImg from "assets/images/bg.png";
import developerdImg from "assets/images/developer_logo.png";
import { Card, CardImg, CardBody, CardText, Badge, Spinner } from "reactstrap";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { toCurrency } from "helpers/common";
import CallModal from "./Modal/CallModal";
import InterestServices from "services/Website/InterestServices";
import { toast } from "react-toastify";
import { addInterest } from "store/Auth/actions";
import { SuccessCreated, SuccessOk } from "configs/statusCode";
import MessageModal from "components/Website/Cards/MessageModal";

const CardComponent = ({ item, history }) => {
	const AuthData = useSelector((state) => state.Auth);
	const currency = useSelector((state) => state.Auth?.currency);
	const { t } = useTranslation();
	const [interestLoading, setInterestLoading] = useState(false);
	const interestServices = new InterestServices();
	const [callModal, setCallModal] = useState(false);
	const [messageModal, setMessageModal] = useState(false);
	const dispatch = useDispatch();

	const isInterested = () => {
		const id = parseInt(item?.id);
		return AuthData.interestsUnits.includes(id);
	};

	const interestHandler = () => {
		const data = { unit_id: item?.id };
		setInterestLoading(true);
		if (!isInterested()) {
			interestServices.createInterest(data).then((response) => {
				if (response && response.status === SuccessCreated) {
					toast.success("Unit Added to Your Interests Successfully");
					dispatch(
						addInterest({
							interestsUnits: [...AuthData.interestsUnits, item.id],
						})
					);
					setInterestLoading(false);
				}
			});
		} else {
			interestServices.deleteInterest(data).then((response) => {
				if (response && response.status === SuccessOk) {
					toast.success("Unit removed from Your interests");
					const updatedInterests = AuthData.interestsUnits.filter(
						(data) => data !== item?.id
					);
					dispatch(addInterest({ interestsUnits: updatedInterests }));
					setInterestLoading(false);
				}
			});
		}
	};

	return (
		<div>
			<div
				className="unit-card "
				onClick={() => history.push(`/property-details/${item?.id}`)}>
				<div className="row g-0">
					<div className="col-md-4 position-relative">
						{item?.images?.length > 0 ? (
							<img src={item?.images?.[0].path} className="imageInside" />
						) : (
							<img className="imageInside" src={compoundImg} />
						)}
						<div
							className="add-to-favourit"
							onClick={(e) => {
								e.stopPropagation();
								interestHandler(item?.id);
							}}>
							<button className="btn p-0 text-center">
								{isInterested() ? (
									<i className="fas fa-heart text-primary font-size-20"></i>
								) : (
									<i className="far fa-heart text-primary font-size-20"></i>
								)}
							</button>
						</div>
					</div>
					<div className="col-md-8">
						<div className="p-3">
							<div className="d-flex justify-content-between">
								<CardText
									tag="h4"
									className="font-size-16 m-0 fw-bold text-color">
									{item?.name[`${AuthData.lang}`]
										? item?.name[`${AuthData.lang}`]
										: item?.name?.en}
								</CardText>
								<span className="text-color font-size-12">
									{item?.unit_type?.name[`${AuthData.lang}`]
										? item?.unit_type?.name[`${AuthData.lang}`]
										: item?.unit_type?.name?.en}
								</span>
							</div>
							{(!!item?.address?.en ||
								!!item?.area?.name?.en ||
								!!item?.city?.name?.name) && (
								<p className="text-color font-size-12 address-compound">
									{item?.address[`${AuthData?.lang}`]
										? item?.address[`${AuthData?.lang}`]
										: item?.address?.en}
									,
									{item?.area?.name[`${AuthData?.lang}`]
										? item?.area?.name[`${AuthData?.lang}`]
										: item?.area?.name?.en}
									,
									{item?.city?.name[`${AuthData?.lang}`]
										? item?.city?.name[`${AuthData?.lang}`]
										: item?.city?.name?.en}
								</p>
							)}
							<div
								className="d-flex py-2 justify-content-between"
								style={{
									borderTop: "1px solid var(--text-color)",
									borderBottom: "1px solid var(--text-color)",
								}}>
								{!!item?.bedrooms && (
									<div>
										<span className="font-size-12 text-color">
											{t("Bedrooms")}
										</span>
										<p className="font-size-14 text-color m-0">
											{item?.bedrooms} {t("rooms")}
										</p>
									</div>
								)}
								{!!item?.bathrooms && (
									<div>
										<span className="font-size-12 text-color">
											{t("Bathrooms")}
										</span>
										<p className="font-size-14 text-color m-0">
											{item?.bathrooms} {t("rooms")}
										</p>
									</div>
								)}
								{!!item?.size && (
									<div>
										<span className="font-size-12 text-color">{t("sqm")}</span>
										<p className="font-size-14 text-color m-0">{item?.size}</p>
									</div>
								)}
							</div>
							<p className="font-size-12 mb-0 mt-2 text-color">{t("Depost")}</p>
							<p className="font-size-14 mb-1 text-color">
								{toCurrency(item?.deposit)} {currency?.currency_code}
							</p>
							<CardText
								tag="h4"
								className="mb-0 d-flex align-items-center justify-content-between">
								<span className="font-size-18 fw-bold text-color">
									{toCurrency(item?.price)} {currency?.currency_code}
								</span>
								<span className="more-information">more information</span>
							</CardText>

							{/* <div className="d-flex">
								<div className="w-100">
									<button
										className="w-100 btn btnCall text-center"
										onClick={(e) => {
											e.stopPropagation();
											setCallModal(true);
										}}>
										<i className="fas fa-phone-alt pe-2"></i>
										{t("call")}
									</button>
								</div>
								<div className="mx-2 w-100">
									<button
										className="w-100 btn btnMessage text-center"
										onClick={(e) => {
											e.stopPropagation();
											setMessageModal(true);
										}}>
										<i className="fa fa-envelope"></i>
									</button>
								</div>
								<div className="mx-2 w-100">
									{interestLoading ? (
										<div className="w-100 d-flex justify-content-center pt-2">
											<Spinner size="sm" color="primary" />
										</div>
									) : (
										<div className="w-100">
											<button
												className="w-100 btn btnMessage text-center"
												onClick={(e) => {
													e.stopPropagation();
													interestHandler();
												}}>
												{isInterested() ? (
													<i className="fas fa-heart text-danger"></i>
												) : (
													<i className="far fa-heart text-danger"></i>
												)}
											</button>
										</div>
									)}
								</div>
							</div> */}
						</div>
					</div>
				</div>
			</div>
			{callModal && (
				<CallModal
					modal={callModal}
					setModal={setCallModal}
					callTypeModal={"unit"}
					phone={item?.sales_rep?.phone}
				/>
			)}
			{messageModal && (
				<MessageModal
					modal={messageModal}
					setModal={setMessageModal}
					item={item}
					type="unit"
				/>
			)}
		</div>
	);
};

export default CardComponent;
